/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import {
  DatePicker,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
  Combobox,
  Button,
  cn,
  Textarea,
} from "@repo/ui";
import { formatDate } from "date-fns";
import { CheckCircle, LucideFileOutput, View } from "lucide-react";
import React, { useContext, useEffect, useState } from "react";
import {
  useConfirmDispatchInterBranchOrders,
  useDownloadInterBranchDispatchDiscrepancy,
  useGetInterBranchOutgoingOrders,
  // useRecordDispatchDiscrepancy,
} from "utils/apis/inter-branch.api";
import {
  useGetContainersDiscrepancy,
  useGetDedicatedShiftRoutes,
} from "utils/apis/lookups.api";
import { showToast } from "utils/helper";
import { UserContext } from "utils/reducers/user";
import RouteDispatchReportGenerator from "./routeDispatchReport";

export default function Dispatch() {
  const currentDate = new Date();
  const user = useContext(UserContext);

  const [ddlRoutes, setDdlRoutes] = useState("");
  const [packagesConsignments, setPackagesConsignments] = useState<any>([]);
  const [consignment, setConsignment] = useState<any>(null);
  const [coinsConsignments, setCoinsConsignments] = useState<any>([]);
  const [operationDate, setOperationDate] = useState(currentDate);
  const [verificationType, setVerificationType] = useState("");
  const [description, setDescription] = useState("");
  const [reason, setReason] = useState("");
  const [remarks, setRemarks] = useState("");
  const [visible, setVisible] = useState(false);

  const { data: routes } = useGetDedicatedShiftRoutes({
    cashCenterId: user.CashCenterId,
    shift: "morning",
    operationDate: formatDate(
      operationDate || currentDate,
      "yyyy-MM-dd'T'00:00:00.000'Z'",
    ),
  });

  const { data: containersDiscrepancyReason } =
    useGetContainersDiscrepancy("Dispatching");
  const {
    mutate: dispatchOrders,
    // isSuccess: dispatchOrdersSuccess,
    isPending: dispatchOrdersPending,
  } = useConfirmDispatchInterBranchOrders();

  const {
    mutate: dispatchDiscrepancyReport,
    data: dispatchDiscrepancyData,
    isPending: dispatchDiscrepancyPending,
  } = useDownloadInterBranchDispatchDiscrepancy();

  const onConfirmValidation = (item: any) => {
    if (!description) return showToast("error", "Select issue first.");
    if (!reason) return showToast("error", "Select issue description first.");

    if (verificationType === "coins") {
      setCoinsConsignments((prev: any) => {
        return prev?.map((i: any) =>
          i.id === item.id
            ? {
                ...item,
                reason,
                description,
                remarks,
                clientVerification: true,
              }
            : { ...i },
        );
      });
    } else {
      setPackagesConsignments((prev: any) => {
        return prev?.map((i: any) =>
          i.sealNo === item.sealNo
            ? {
                ...item,
                reason,
                description,
                remarks,
                clientVerification: true,
              }
            : {
                ...i,
              },
        );
      });
    }

    setVisible(false);
    setDescription("");
    setReason("");
    setRemarks("");
  };

  const onConfirmDispatchBtnClicked = () => {
    dispatchOrders({
      cashCenterId: user.CashCenterId,
      operationDate: formatDate(
        operationDate || currentDate,
        "yyyy-MM-dd'T'00:00:00.000'Z'",
      ),
      routeNo: ddlRoutes,
      shift: "morning",
      consignments: packagesConsignments?.map((i: any) => ({
        ...i,
        isValidated: i.isValidated ? true : i.clientVerification,
      })),
      coinsBoxes: coinsConsignments?.map((i: any) => ({
        ...i,
        isValidated: i.isValidated ? true : i.clientVerification,
      })),
    });
  };

  const onDownloadReport = () => {
    if (!ddlRoutes) showToast("error", "Select Route No.");
    dispatchDiscrepancyReport({
      cashCenterId: user.CashCenterId,
      shift: "morning",
      operationDate: formatDate(
        operationDate || currentDate,
        "yyyy-MM-dd'T'00:00:00.000'Z'",
      ),
      routeNo: ddlRoutes,
    });
  };

  const handleValidationModal = (item: any, type: string) => {
    setVerificationType(type);
    setConsignment(item);
    setVisible(true);
  };

  const {
    data: outgoingOrders,
    isSuccess: outgoingOrdersSuccess,
    isError: outgoingOrdersError,
    isFetching: loadingRequests,
  } = useGetInterBranchOutgoingOrders({
    cashCenterId: user.CashCenterId,
    operationDate: formatDate(
      operationDate || currentDate,
      "yyyy-MM-dd'T'00:00:00.000'Z'",
    ),
    shift: "morning",
    routeNo: ddlRoutes,
    isFetchOnMount: true,
  });

  useEffect(() => {
    if (outgoingOrdersSuccess && !outgoingOrders?.isReadyForDispatch) {
      setPackagesConsignments(outgoingOrders?.sealedPackages);
      setCoinsConsignments(
        outgoingOrders?.coinsBoxes?.map((i) => ({
          ...i,
          id: crypto.randomUUID(),
        })),
      );
    }
    if (outgoingOrdersError) {
      setPackagesConsignments([]);
      setCoinsConsignments([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [outgoingOrdersSuccess, outgoingOrdersError]);

  return (
    <>
      <div className="flex mt-3 gap-2">
        <div className="w-full max-w-[320px]">
          <DatePicker
            selectedDate={operationDate}
            onSelectDate={setOperationDate}
            placeholder="Select Date"
          />
        </div>
        <div className="w-full max-w-[320px]">
          <Combobox
            value={ddlRoutes}
            data={routes?.map((route) => ({
              value: route.routeNo,
              label: `${route.routeNo} (${route.description})`,
            }))}
            placeholder="Select Route"
            setValue={setDdlRoutes}
          />
        </div>
        <Button
          variant="secondary"
          className="max-w-[200px] w-full ml-auto"
          onClick={onConfirmDispatchBtnClicked}
          isLoading={dispatchOrdersPending}
        >
          Save
        </Button>

        <Button
          variant="secondary"
          className="max-w-[200px] w-full"
          isLoading={dispatchDiscrepancyPending}
          onClick={onDownloadReport}
        >
          <LucideFileOutput /> Download
        </Button>
        {dispatchDiscrepancyData ? (
          <RouteDispatchReportGenerator data={dispatchDiscrepancyData} />
        ) : null}
      </div>
      <div className="border-b my-3 bg-accent" />
      {loadingRequests ? (
        <div className="k-loading-mask">
          <span className="k-loading-text">Loading</span>
          <div className="k-loading-image" />
          <div className="k-loading-color" />
        </div>
      ) : null}
      <div className="flex gap-3">
        <div className="flex-[0.5]">
          <h4 className="font-semibold text-lg mb-3">Packages</h4>
          {packagesConsignments?.length ? (
            <Grid data={packagesConsignments}>
              <GridColumn field="containerType" title="Container" />
              <GridColumn field="sealNo" title="Seal No." />
              <GridColumn field="discrepancyType" title="Discrepancy" />
              <GridColumn
                title="Status"
                field="isValidated"
                cell={({ field, dataItem }) => {
                  return (
                    <td>
                      {field && dataItem[field] ? (
                        <span className="text-green-500">Successful</span>
                      ) : (
                        <span className="text-red-500">Discrepancy</span>
                      )}
                    </td>
                  );
                }}
              />
              <GridColumn
                field="isValidated"
                title="Action"
                cell={({ field, dataItem }) => (
                  <td>
                    {field && !dataItem[field] ? (
                      <Button
                        variant="outline"
                        className={cn(
                          "text-white hover:text-black",
                          dataItem?.clientVerification
                            ? "bg-green-500"
                            : "bg-red-500",
                        )}
                        onClick={() => {
                          handleValidationModal(dataItem, "packages");
                        }}
                      >
                        <CheckCircle />
                      </Button>
                    ) : (
                      <Button
                        variant="secondary"
                        onClick={() => {
                          handleValidationModal(dataItem, "view");
                        }}
                      >
                        <View />
                      </Button>
                    )}
                  </td>
                )}
              />
            </Grid>
          ) : null}
        </div>
        <div className="flex-[0.5]">
          <h4 className="font-semibold text-lg mb-3">Coins</h4>
          {coinsConsignments?.length ? (
            <Grid data={coinsConsignments}>
              <GridColumn field="containerType" title="Container" />
              <GridColumn field="denomination" title="Denomination" />
              <GridColumn field="count" title="Count" />
              <GridColumn field="discrepancyType" title="Discrepancy" />
              <GridColumn
                title="Status"
                field="isValidated"
                cell={({ field, dataItem }) => {
                  return (
                    <td>
                      {field && dataItem[field] ? (
                        <span className="text-green-500">Successful</span>
                      ) : (
                        <span className="text-red-500">Discrepancy</span>
                      )}
                    </td>
                  );
                }}
              />
              <GridColumn
                field="isValidated"
                title="Action"
                cell={({ field, dataItem }) => (
                  <td>
                    {field && !dataItem[field] ? (
                      <Button
                        variant="outline"
                        className={cn(
                          "text-white hover:text-black",
                          dataItem?.clientVerification
                            ? "bg-green-500"
                            : "bg-red-500",
                        )}
                        onClick={() => {
                          handleValidationModal(dataItem, "coins");
                        }}
                      >
                        <CheckCircle />
                      </Button>
                    ) : (
                      <Button
                        variant="secondary"
                        onClick={() => {
                          handleValidationModal(dataItem, "view");
                        }}
                      >
                        <View />
                      </Button>
                    )}
                  </td>
                )}
              />
            </Grid>
          ) : null}
        </div>
      </div>
      <Dialog
        open={visible}
        onOpenChange={(val) => {
          setDescription("");
          setReason("");
          setRemarks("");
          setVisible(val);
        }}
      >
        <DialogContent className="max-w-[760px]">
          <DialogHeader>
            <DialogTitle>
              {verificationType === "view"
                ? "Validation Detail"
                : "Validate Bag"}
            </DialogTitle>
          </DialogHeader>
          <DialogDescription className="pt-6 text-black">
            <div className="flex gap-3 flex-wrap">
              <div className="flex gap-2 w-[calc(50%_-_8px)]">
                <strong>Route:</strong>
                <span>{outgoingOrders?.routeNo}</span>
              </div>
              <div className="flex gap-2 w-[calc(50%_-_8px)]">
                <strong>Shift:</strong>
                <span>{outgoingOrders?.shift}</span>
              </div>
              <div className="flex gap-2 w-[calc(50%_-_8px)]">
                <strong>Team Leader:</strong>
                <span>
                  {outgoingOrders?.teamLeaderName} (
                  {outgoingOrders?.teamLeaderId})
                </span>
              </div>
              {consignment?.sealNo ? (
                <div className="flex gap-2 w-[calc(50%_-_8px)]">
                  <strong>Seal No:</strong>
                  <span>{consignment?.sealNo}</span>
                </div>
              ) : null}
              <div className="w-full flex gap-2 items-center">
                <strong className="w-[30%]">
                  Issue
                  {verificationType === "view" ? (
                    ":"
                  ) : (
                    <sup className="text-red-500">*</sup>
                  )}
                </strong>
                {verificationType === "view" ? (
                  consignment?.description
                ) : (
                  <Select onValueChange={setDescription} value={description}>
                    <SelectTrigger>
                      <SelectValue placeholder="Select Issue Type" />
                    </SelectTrigger>
                    <SelectContent>
                      {containersDiscrepancyReason?.map((item: any) => (
                        <SelectItem
                          key={item.description}
                          value={item.description}
                        >
                          {item.description}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                )}
              </div>
              <div className="w-full flex gap-2 items-center">
                <strong className="w-[30%]">
                  Issue Description
                  {verificationType === "view" ? (
                    ":"
                  ) : (
                    <sup className="text-red-500">*</sup>
                  )}
                </strong>
                {verificationType === "view" ? (
                  consignment?.reason
                ) : (
                  <Select onValueChange={setReason} value={reason}>
                    <SelectTrigger>
                      <SelectValue placeholder="Select Shift" />
                    </SelectTrigger>
                    <SelectContent>
                      {containersDiscrepancyReason
                        ?.find((item) => item.description === description)
                        ?.subReasons?.map((item: any) => (
                          <SelectItem
                            key={item.description}
                            value={item.description}
                          >
                            {item.description}
                          </SelectItem>
                        ))}
                    </SelectContent>
                  </Select>
                )}
              </div>
              <div className="w-full flex gap-2 items-center">
                <strong className="w-[30%]">Remarks</strong>
                {verificationType === "view" ? (
                  consignment?.remarks
                ) : (
                  <Textarea
                    value={remarks}
                    onChange={(e) => {
                      setRemarks(e.target.value);
                    }}
                  />
                )}
              </div>
            </div>
            {verificationType !== "view" && (
              <div className="flex justify-end gap-3 mt-3">
                <Button
                  variant="outline"
                  onClick={() => {
                    setVisible(false);
                    setDescription("");
                    setReason("");
                    setRemarks("");
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="secondary"
                  onClick={() => {
                    onConfirmValidation(consignment);
                  }}
                >
                  Validate
                </Button>
              </div>
            )}
          </DialogDescription>
        </DialogContent>
      </Dialog>
    </>
  );
}
